"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkspacesMap = getWorkspacesMap;
exports.packageJsonBelongsToWorkspace = packageJsonBelongsToWorkspace;
exports.processNpmWorkspaces = processNpmWorkspaces;
const baseDebug = require("debug");
const pathUtil = require("path");
const lodash_1 = require("lodash");
const micromatch = require("micromatch");
const debug = baseDebug('snyk-npm-workspaces');
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const utils_1 = require("../utils");
const errors_1 = require("../errors");
function getWorkspacesMap(file) {
    const workspacesMap = {};
    if (!file) {
        return workspacesMap;
    }
    try {
        const rootFileWorkspacesDefinitions = JSON.parse(file.content).workspaces || false;
        if (rootFileWorkspacesDefinitions && rootFileWorkspacesDefinitions.length) {
            workspacesMap[file.fileName] = {
                workspaces: rootFileWorkspacesDefinitions,
            };
        }
    }
    catch (e) {
        debug('Failed to process a workspace', e.message);
    }
    return workspacesMap;
}
function packageJsonBelongsToWorkspace(packageJsonFileName, workspacesMap, workspaceRoot) {
    const workspaceRootFolder = pathUtil.dirname(workspaceRoot.replace(/\\/g, '/'));
    const workspacesGlobs = (workspacesMap[workspaceRoot].workspaces || []).map((workspace) => pathUtil.join(workspaceRootFolder, workspace));
    const match = micromatch.isMatch(packageJsonFileName.replace(/\\/g, '/'), workspacesGlobs.map((p) => pathUtil.normalize(pathUtil.join(p, 'package.json')).replace(/\\/g, '/')));
    return match;
}
async function processNpmWorkspaces(root, settings, targetFiles) {
    // the order of npmTargetFiles folders is important
    // must have the root level most folders at the top
    const mappedAndFiltered = targetFiles
        .map((p) => ({ path: p, ...pathUtil.parse(p) }))
        .filter((res) => ['package.json', 'package-lock.json'].includes(res.base));
    const sorted = (0, lodash_1.sortBy)(mappedAndFiltered, 'dir');
    const npmTargetFiles = (0, lodash_1.groupBy)(sorted, 'dir');
    debug(`Processing potential Npm workspaces (${targetFiles.length})`);
    if (settings.yarnWorkspaces && Object.keys(npmTargetFiles).length === 0) {
        throw (0, errors_1.NoSupportedManifestsFoundError)([root]);
    }
    let npmWorkspacesMap = {};
    const workspacesFilesMap = {};
    const result = {
        plugin: {
            name: 'snyk-nodejs-npm-workspaces',
            runtime: process.version,
        },
        scannedProjects: [],
    };
    // the folders must be ordered highest first
    for (const directory of Object.keys(npmTargetFiles)) {
        debug(`Processing ${directory} as a potential npm workspace`);
        let isWorkspacePackage = false;
        let isRootPackageJson = false;
        const packageJsonFileName = pathUtil.join(directory, 'package.json');
        const packageJson = (0, utils_1.getFileContents)(root, packageJsonFileName);
        npmWorkspacesMap = {
            ...npmWorkspacesMap,
            ...getWorkspacesMap(packageJson),
        };
        for (const workspaceRoot of Object.keys(npmWorkspacesMap)) {
            const match = packageJsonBelongsToWorkspace(packageJsonFileName, npmWorkspacesMap, workspaceRoot);
            if (match) {
                debug(`${packageJsonFileName} matches an existing workspace pattern`);
                workspacesFilesMap[packageJsonFileName] = {
                    root: workspaceRoot,
                };
                isWorkspacePackage = true;
            }
            if (packageJsonFileName === workspaceRoot) {
                isRootPackageJson = true;
            }
        }
        if (!(isWorkspacePackage || isRootPackageJson)) {
            debug(`${packageJsonFileName} is not part of any detected workspace, skipping`);
            continue;
        }
        try {
            const rootDir = isWorkspacePackage
                ? pathUtil.dirname(workspacesFilesMap[packageJsonFileName].root)
                : pathUtil.dirname(packageJsonFileName);
            const rootLockfileName = pathUtil.join(rootDir, 'package-lock.json');
            const lockContent = (0, utils_1.getFileContents)(root, rootLockfileName);
            const res = await lockFileParser.parseNpmLockV2Project(packageJson.content, lockContent.content, {
                includeDevDeps: settings.dev || false,
                strictOutOfSync: settings.strictOutOfSync || false,
                includeOptionalDeps: false,
                pruneCycles: true,
                showNpmScope: settings.showNpmScope,
            });
            const project = {
                packageManager: 'npm',
                targetFile: pathUtil.relative(root, packageJson.fileName),
                depGraph: res,
                plugin: {
                    name: 'snyk-nodejs-lockfile-parser',
                    runtime: process.version,
                },
            };
            result.scannedProjects.push(project);
        }
        catch (e) {
            if (settings.yarnWorkspaces) {
                throw e;
            }
            debug(`Error process workspace: ${packageJsonFileName}. ERROR: ${e}`);
        }
    }
    if (!result.scannedProjects.length) {
        debug(`No npm workspaces detected in any of the ${targetFiles.length} target files.`);
    }
    return result;
}
//# sourceMappingURL=npm-workspaces-parser.js.map